import i18next from "i18next";
import LngDetector from "i18next-browser-languagedetector";
import XHR from "i18next-xhr-backend";
import { I18nMessageDefinition, isI18nMessageDefinition } from "./I18nMessage";
import { LoadStatus } from "./loadStatus";

declare const __BUILDTIME__: string;
declare const __DEBUG_I18N__: boolean;

export class S6i18n {
    public instance: i18next.i18n;
    private namespaces = {
        translation: "locales/{{lng}}/translations.json?v=" + __BUILDTIME__,
    };
    private loadStatus: LoadStatus;
    private languages: string[];

    public init(languages: string[], callback): void {
        this.setLanguages(languages);
        this.loadStatus = new LoadStatus();
        this.i18nextOptions.whitelist = this.getLanguages();
        this.i18nextOptions.debug = __DEBUG_I18N__;
        i18next
            .use(XHR as unknown as i18next.Module)
            .use(LngDetector as unknown as i18next.Module)
            .init(this.i18nextOptions,
                (e, t) => {
                    callback();
                });
        this.instance = i18next;
    }

    private getLoadPath = (lng, namespace) => {
        return this.namespaces[namespace].replace("{{lng}}", lng);
    }

    private i18nextOptions = {
        fallbackLng: "es",
        whitelist: this.getLanguages(),
        debug: true,
        backend: {
            loadPath: this.getLoadPath,
            parse: (data) => data,
            ajax: this.loadRawLocales,
        },
    };

    private loadRawLocales(url, options, callback, data) {
        fetch(url, {
            method: "get",
        }).then((response) => response.json()).then((json) => {
            callback(json, { status: "200" });
        }).catch((e) => {
            console.error(e, url);
            callback(null, { status: "404" });
        });
    }

    public loadRemoteNamespace(namespace, url, callback): void {
        this.loadStatus.setCallback(callback);
        this.loadStatus.register(namespace);
        this.namespaces[namespace] = url;
        this.instance.loadNamespaces(namespace, () => {
            this.loadStatus.unregister(namespace);
            // console.info("Loaded " + namespace);
        });
    }

    public getLanguages(): string[] {
        return this.languages;
    }

    public setLanguages(languages): void {
        this.languages = languages;
    }

    public t(message: string | I18nMessageDefinition): string {
        if (isI18nMessageDefinition(message)) {
            return this.instance.t(message.key, message.args);
        } else {
            return this.instance.t(message);
        }
    }
}

const instance = new S6i18n();
export default instance;
